import { useMemo } from "react";
import useQuery from "hooks/useQuery";
import IntercomService from "services/IntercomService";
import UserService from "services/UserService";

function useGetIntercomToken(enabled = true) {
  const userId = useMemo(() => UserService.currentUser?.uid, []);
  const key = useMemo(
    () => (enabled && userId ? ["IntercomService.getSigningToken", userId] : null),
    [enabled, userId]
  );
  const { data, status } = useQuery(key, () => IntercomService.getSigningToken());
  return useMemo(() => ({ data, status }), [data, status]);
}

export default useGetIntercomToken;
